export default __webpack_public_path__ + "static/media/search-icon.7ced6396.svg";